var cilExpandRight = ["512 512", "<rect width='32' height='480' x='40' y='19' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M392,499H520V19H392ZM424,51h64V467H424Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M120,419h37.86L327.224,259.077,159.921,99H120Zm32-283.291L280.776,258.924,152,380.522Z' class='ci-primary'/>"];

export { cilExpandRight };

